export default {
  teams: state => state.teams,
  team: state => state.team,
  teamLead: state => state.teamLead,
  technicians: state => state.technicians,
  activeTab: state => state.activeTab,
  tabs: state => state.tabs,
  teamTree: state => state.teamTree,
  selectedId: state => state.selectedId,
  selectedTeamId: state => state.selectedTeamId,
  selectedTeamMemberId: state => state.selectedTeamMemberId,
  teamMembers: state => state.teamMembers,
  teamMemberId: state => state.teamMemberId,
  teamMemberIds: state => state.teamMemberIds,
  teamMemberProfile: state => state.teamMemberProfile,
  selectedContactId: state => state.selectedContactId,
  teamMemberProfileId: state => state.teamMemberProfileId,
  selectedTeamName: state => state.selectedTeamName,
  selectedTeamMemberName: state => state.selectedTeamMemberName,
  selectedTeamMemberProfile: state => state.selectedTeamMemberProfile,
  selectedTeamMembers: state => state.selectedTeamMembers,
  selectedTimeZone: state => state.selectedTimeZone,
  selectedTimeZoneList: state => state.selectedTimeZoneList,
  selectedLanguageList: state => state.selectedLanguageList,
  selectedMakeList: state => state.selectedMakeList,
  selectedRegionList: state => state.selectedRegionList,
  selectedScanTypeCertificationList: state => state.selectedScanTypeCertificationList,
  selectedStateCertificationList: state => state.selectedStateCertificationList,
  memberAttributeOptions: state => state.memberAttributeOptions,
  memberAttributeSelectedValues: state => state.memberAttributeSelectedValues,
  memberAttributeLabel: state => state.memberAttributeLabel,
  attributes: state => state.attributes,
  uniqueAttributes: state => state.uniqueAttributes,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  certificationIdsList: state => state.stateCertificationIds,
  isCertificationIddisabled: state => state.isCertificationIddisabled
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/teams/getters.js